// extracted by mini-css-extract-plugin
module.exports = {"authOTPModalWrapper":"VerifyOTP_authOTPModalWrapper__dp3sN"};